<div class="callback-shell">
  <section class="callback-card">
    @if (errorMessage) {
      <h1>Google sign-in could not finish</h1>
      <p>{{ errorMessage }}</p>
      <a routerLink="/login">Return to sign in</a>
    } @else {
      <ion-spinner name="crescent"></ion-spinner>
      <h1>Finishing secure sign-in</h1>
      <p>Please keep this page open for a moment.</p>
    }
  </section>
</div>
